import store from "./store";

export * from "./store";
export * from "./reducers";

export default store;
